const ERROR_MAP = {
  'OW':          'Only owner can perform this action',
  'OA':          'Only admin can perform this action',
  'OOA':         'Only owner or admin can perform this action',
  'OL':          'Only authorized logic contract can call this',
  'OS':          'Only authorized spender can call this',
  'REG':         'Address already registered',
  'NR':          'User not registered',
  'IR':          'Invalid referrer',
  'IP':          'Invalid package',
  'IL':          'Invalid level',
  'IM':          'Invalid milestone',
  'IA':          'Invalid address',
  'IV':          'Invalid value',
  'BL':          'User is blacklisted',
  'NA':          'User is not active',
  'NIL':         'Nothing to claim',
  'CB':          'Insufficient claimable balance',
  'EB':          'Insufficient expense balance',
  'AD0':         'No active directs to decrement',
  'EX':          'User already exists',
  'PROT':        'Protected user (owner/admin)',
  'NF':          'User not found',
  'AR':          'Already rewarded',
  'NE':          'Not eligible',
  'EMPTY':       'Pool is empty',
  'NO_ELIGIBLE': 'No eligible users',
  'SMALL':       'Amount too small to distribute',
  'PRICE':       'Zenova price not set',
  'TINY':        'Amount too tiny to convert',
  'TF':          'Token transfer failed',
  'SUM':         'Sum must total 100%',
  'F50':         'Fee cannot exceed 50%',
  'P100':        'Percentage cannot exceed 100%',
  'MIN':         'Below minimum bound',
  'MAX':         'Above maximum bound',
  'NOID':        'Could not generate ID'
};

export const parseError = (err) => {
  if (!err) return 'Unknown error';

  // User rejected
  const code = err.code;
  if (code === 4001 || code === 'ACTION_REJECTED') {
    return 'Transaction rejected by user';
  }

  // Extract revert reason from various shapes
  let reason = null;

  if (err.reason) reason = err.reason;
  else if (err.data && err.data.message) reason = err.data.message;
  else if (err.error && err.error.message) reason = err.error.message;
  else if (err.message) reason = err.message;

  if (!reason) return 'Transaction failed';

  // Match error codes
  const clean = reason.replace(/^execution reverted:?\s*/i, '').trim();

  // Try exact match
  if (ERROR_MAP[clean]) return ERROR_MAP[clean];

  // Try to extract short revert code (e.g. "OW", "IR")
  const match = clean.match(/[\s"']([A-Z0-9_]{2,20})["']?\s*$/);
  if (match && ERROR_MAP[match[1]]) return ERROR_MAP[match[1]];

  // Common wallet errors
  if (/insufficient funds/i.test(reason)) return 'Insufficient funds for gas';
  if (/nonce/i.test(reason)) return 'Nonce error — please retry';
  if (/gas required exceeds/i.test(reason)) return 'Gas estimation failed';
  if (/network changed/i.test(reason)) return 'Network changed during transaction';

  // Fallback — first 120 chars
  return clean.length > 120 ? clean.slice(0, 120) + '...' : clean;
};
